<template>
    <div>
        <CaseFile chart-type="ClientSubProgramMembership" :chart-record-id="ChartRecordId" :sub-program-id="SubProgramId" />
    </div>
</template>

<script>
    import CaseFile from '../Core/RecordComponents/CaseFile.vue';

    export default {
        name: "EmbedCaseFile",
        props: [

        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            
        },
        components: {
            CaseFile
        },
        computed: {
            ChartRecordId: function () {
                return this.$route.query.ChartRecordId
            },
            SubProgramId: function () {
                return this.$route.query.SubProgramId
            },
        },
    }
</script>